import { z } from "zod";

/**
 * Assistant behavior settings (Twilio-specific variant)
 */
export const DeploymentAssistantSettingsSchema = z.object({
  temperature: z.number().min(0).max(2).optional(),
  maxTokens: z.number().optional(),
  systemPromptAddition: z.string().optional(),
  // Extended fields for phone call deployments
  enabledSkills: z.unknown().optional(),
  enableKnowledges: z.boolean().optional(),
  enableInternetSearch: z.boolean().optional(),
  enableSendDocuments: z.boolean().optional(),
  sendDocumentsType: z.array(z.string()).optional(),
  sendDocumentsTasksEnabled: z.array(z.string()).optional(),
  sendDocumentsConfigType: z.string().optional()
});

export type DeploymentAssistantSettings = z.infer<typeof DeploymentAssistantSettingsSchema>;
